import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { RightChevron } from 'baby-design/icons'

import { shipmentDetailViewPath } from 'lib/urls'

import { Shipment } from 'src/types/shipments'

import LabelAndInfo from '../LabelAndInfo'
import ShipmentStatusBadge from '../../ShipmentStatusBadge'

import styles from './ShipmentStatusRow.styles.scss'
import { shipmentStatusLabelAndInfo } from './ShipmentStatusRow.util'

const ShipmentStatusRow: FC<{ shipment: Shipment }> = ({
  shipment: { id, shipmentStatus, shippedToRegistrant },
}) => {
  if (!shipmentStatus) {
    return null
  }

  const labelAndInfo = shipmentStatusLabelAndInfo(shipmentStatus)
  if (!labelAndInfo) {
    return null
  }

  const { label, info } = labelAndInfo
  if (!label) {
    return null
  }

  const { currentState } = shipmentStatus

  const href = shippedToRegistrant ? shipmentDetailViewPath(id) : undefined

  return (
    <a
      className={styles.ShipmentStatusRow}
      data-testid="ShipmentStatusRow"
      href={href}
    >
      <LabelAndInfo info={info} label={label} />
      <div className={styles.ShipmentStatusRow__badge_and_button}>
        {currentState && <ShipmentStatusBadge currentState={currentState} />}
        {shippedToRegistrant && <RightChevron />}
      </div>
    </a>
  )
}

export default ShipmentStatusRow
